<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('customer_budget_payment')" :isNewButton="checkPermission('customerbudgetpayment_store')"
                        @new-button-click="createFormShow()" :isFilter="false" :other-button="excelExportData" @downloadExcel="downloadExcel">
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('customer_budget_payment')" :isNewButton="checkPermission('customerbudgetpayment_store')"
                              @new-button-click="createFormShow()"
                              :isFilter="false"
                              :other-button="excelExportData"
                              @downloadExcel="downloadExcel"
                >
                </HeaderMobile>
            </template>
            <b-row class="mb-5 align-items-center" v-if="data != null">
                <b-col>
                    <h5>{{ $t('customer_budget_information') }}</h5>
                </b-col>
                <b-col cols="12">
                    <b-row class="border mb-2 p-2">
                        <b-col cols="12" sm="6" md="6" lg="4" xl="3">
                            <b-form-group :label="$t('student_number')">
                                {{ data.number }}
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="6" md="6" lg="4" xl="3">
                            <b-form-group :label="$t('name_surname')">
                                {{ data.name }} {{ data.surname }}
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="6" md="6" lg="4" xl="3">
                            <b-form-group :label="$t('subject')">
                                {{ data.subject }}
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="6" md="6" lg="4" xl="3">
                            <b-form-group :label="$t('academic_year')">
                                {{ data.academic_year }}
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="6" md="6" lg="4" xl="3">
                            <b-form-group :label="$t('issue_date')">
                                {{ $moment(data.issue_date).format("DD/MM/YYYY") }}

                            </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="6" md="6" lg="4" xl="3">
                            <b-form-group :label="$t('amount')">
                                {{ this.formatNumber(data.amount) }}
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="6" md="6" lg="4" xl="3">
                            <b-form-group :label="$t('currency')">
                                {{ data.currency }}
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="6" md="6" lg="4" xl="3">
                            <b-form-group :label="$t('total_payment')">
                                {{ this.formatNumber(data.total_payment) }}
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="6" md="6" lg="4" xl="3">
                            <b-form-group :label="$t('balance')">
                                {{ this.formatNumber(data.balance) }}
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <datatable :isLoading.sync="datatable.isLoading" :columns="datatable.columns" :rows="datatable.rows"
                       :total="datatable.total" :queryParams="datatable.queryParams" @on-page-change="onPageChange"
                       @on-sort-change="onSortChange" @on-per-page-change="onPerPageChange" v-show="datatable.showTable">
            </datatable>
            <CommonModal ref="createFormModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t('new').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <payment-create @createFormSuccess="createFormSuccess" :formId="id" v-if="formProcess == 'create'" />
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
// Template
import AppLayout from "@/layouts/AppLayout.vue"
import Header from "@/layouts/AppLayout/Header.vue"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile.vue"

// Components
import Datatable from "@/components/datatable/Datatable.vue";
import CommonModal from "@/components/elements/CommonModal.vue";

// Pages
import PaymentCreate from "./PaymentCreate.vue";

// Services
import CustomerBudgetPaymentService from "@/services/CustomerBudgetPaymentService";
import CustomerBudgetService from "@/services/CustomerBudgetService";
import qs from "qs";

export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,
        Datatable,
        CommonModal,
        PaymentCreate,

    },
    metaInfo() {
        return {
            title: this.$t('customer_budget_payment')
        }
    },

    data() {
        return {
            id: this.$route.params.id,
            data: null,
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: '',
                        field: 'buttons',
                        html: true,
                        sortable: false,
                        tdClass: 'p-0 text-center w-40 align-middle',
                        buttons: [
                            {
                                text: this.$t('delete'),
                                class: 'ri-delete-bin-7-line align-middle top-minus-1 mr-3 text-muted',
                                permission: "customerbudgetpayment_delete",
                                callback: (row) => {
                                    this.formDelete(row.id)
                                }
                            }
                        ]
                    },
                    {
                        label: this.toUpperCase('id'),
                        field: 'id',
                        hidden: true,
                    },
                    {
                        label: this.toUpperCase('type'),
                        field: this.getLocaleField('type_name'),
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('payment_date'),
                        field: 'payment_date',
                        formatFn: (value, row) => {
                            return this.$moment(row.payment_date).format("DD/MM/YYYY")
                        },
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('amount'),
                        field: 'amount',
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('explanation'),
                        field: 'explanation',
                        hidden: false,
                    }
                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    filter: {},
                    sort: 'id',
                    page: 1,
                    limit: 20
                }
            },
            formProcess: null,
            formId: null,
            form: {},
            academic_year: null
        }
    },
    created() {
        this.loadData()
        this.loadPayments()
    },
    computed: {
        excelExportData() {
            return {
                title: this.$t("excel"),
                show: this.checkPermission('customerbudgetpayment_excelexport'),
                icon:'ri-download-2-line',
                emit:'downloadExcel'
            };
        }
    },
    methods: {
        filter() {
            this.datatable.queryParams.page = 1;
            this.loadPayments();
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.loadPayments();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.loadPayments();
        },
        changeColumn(key) {
            this.datatable.columns[key].hidden = this.datatable.columns[key].hidden == true ? false : true;
        },
        onSortChange(params) {
            const sortType = params[0].type == 'desc' ? '-' : '';
            this.datatable.queryParams.sort = sortType + params[0].field
            this.loadPayments();
        },
        loadData() {
            CustomerBudgetService.get(this.id)
                .then(response => {
                    this.data = response.data.data;
                    if (this.data && this.data.academic_year) {
                        this.academic_year = this.data.academic_year;
                    } else {
                        this.academic_year = null;
                    }
                }).catch(error => {
                if (error.data.message) {
                    this.$toast.error(this.$t('api.' + error.data.message));
                }
            });
        },
        loadPayments() {
            this.datatable.showTable = true;
            this.datatable.isLoading = true;

            const config = {
                params: {
                    filter: {
                        customer_budget_id: this.id,
                    },
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false}),
            };
            return CustomerBudgetPaymentService.getAll(config)
                .then((response) => {
                    this.datatable.rows = response.data.data
                })
                .finally(() => {
                    this.datatable.isLoading = false;
                });
        },
        // Clear
        formClear() {
            this.formId = null
            this.formProcess = null
        },
        // Create
        createFormShow() {
            this.formId = null
            this.formProcess = 'create'
            this.$refs.createFormModal.$refs.commonModal.show()
        },
        createFormSuccess() {
            this.$refs.createFormModal.$refs.commonModal.hide()
            this.loadPayments()
            this.formClear()
        },
        formDelete(id) {
            this.$swal
                .fire({
                    text: this.$t('are_you_sure_to_delete'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no'),
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        CustomerBudgetPaymentService.del(id)
                            .then(response => {
                                this.$toast.success(this.$t('api.' + response.data.message));
                                this.loadPayments();
                                this.formClear();
                            })
                            .catch(error => {
                                this.$toast.error(this.$t('api.' + error.data.message));
                            });
                    }
                })
        },
        downloadExcel(){
            const config= {
                params: {
                    filter: {
                        customer_budget_id: this.id,
                    },
                },
                responseType:'arraybuffer',
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            };
            return CustomerBudgetPaymentService.exportExcel(config)
                .then((response) => {
                    this._downloadFile(response,this.$t('customer_budget_payment')+'.xlsx')
                })
                .catch(err=>this.showErrors(err))
        },

    }
}
</script>

